import { Either, right, left } from "fp-ts/lib/Either";
import di from "../../../../DependencyInjection";
import HostApi, { HostApiName } from "../../../settings/HostApi";
import ErrorEntity, { ErrorEntityFromError } from "../../../../domain/entities/ErrorEntity";

const LogOutApiImpl = async(): Promise<Either<ErrorEntity, void>> => {
    try {
        di.get<HostApi>(HostApiName).removeToken();
        await di.get<HostApi>(HostApiName).post("/logout", {});
        return right(undefined);
    } catch (e) {
        console.error(e);
        return left(ErrorEntityFromError(e));
    }
}

export default LogOutApiImpl;